import { type ReactNode } from 'react';
import { Box } from '@leagueplatform/genesis-core';

// Bordered card chrome shared by the Settings section cards (Personal Info,
// Communication Preferences, etc.). Wraps arbitrary content; row-based cards
// compose `InfoSection` instead, which renders its own card chrome.
export const SectionCard = ({ children }: { children: ReactNode }) => (
  <Box
    as="section"
    css={{
      width: '100%',
      borderWidth: '$card',
      borderStyle: 'solid',
      borderColor: '$onSurfaceBorderSubdued',
      borderRadius: '$medium',
      paddingBlock: '$two',
      paddingInline: '$oneAndHalf',
      backgroundColor: '$surfaceBackgroundPrimary',
    }}
  >
    {children}
  </Box>
);
